import { gql } from '@apollo/client';

export const GameRoomUpdated = gql`
  subscription GameRoomUpdated($roomId: String!) {
    gameRoomUpdated(roomId: $roomId) {
      id
      code
      hostId
      status
      mode
      pack
      players {
        id
        userId
        score
        online
        user {
          id
          firstName
          lastName
        }
      }
      currentRound {
        id
        roundNumber
        status
        impostorId
        secretWord
        outcome
        clues {
          id
          playerId
          word
          order
        }
        votes {
          id
          voterId
          targetId
        }
      }
      rounds {
        id
        roundNumber
        status
        impostorId
        secretWord
        outcome
      }
    }
  }
`;

export const GameChatMessage = gql`
  subscription GameChatMessage($roomId: String!) {
    gameChatMessage(roomId: $roomId) {
      id
      roomId
      senderId
      sender {
        id
        firstName
      }
      text
      audioUrl
      duration
      sentAt
    }
  }
`;
